<td></td>
<tr style="border-bottom: 2px solid black;">
  <td colspan="11"></td>
</tr>
<td></td>
<td></td>
<td></td>
<td></td>
<td></td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.excedido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[0]?.excedido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[0]?.excedido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[0]?.excedido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  }
</td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.excedido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionExcedido - cliente.solicitudesCrediticias[0]?.excedido?.monto | number: '1.0-0'}}</p>
    </div>
  }
</td>
<td></td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.vencido){
    <div class="fondo mt-2">
      <p style="margin: 0;">${{cliente.solicitudesCrediticias[0]?.vencido?.monto | number: '1.0-0'}}</p>
      <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[0]?.vencido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[0]?.vencido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
    </div>
  }
</td>
<td>
  @if (cliente.solicitudesCrediticias[0]?.vencido){
    <div class="fondo">
      <p style="margin: 0;">${{cliente.situacionVencido - cliente.solicitudesCrediticias[0]?.vencido?.monto  | number: '1.0-0'}}</p>
    </div>
  }
</td>
<td>
  <div style="justify-content: center" class="d-flex align-items-center fondo">
    @if (cargandoPendiente[i] && !cargandoPendiente[i][0]){
      <span class="me-2">Pendiente</span>
      @if (cliente.solicitudesCrediticias[0]?.vencido?.monto && cliente.solicitudesCrediticias[0]?.excedido?.monto){
        <button type="button" [disabled]="anulando" (click)="anularPendiente(i, 0, cliente.solicitudesCrediticias[0], accionEliminar.Ambos)"
                class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
          <i class="fa fa-trash" style="transform: scale(1.5)"></i>
        </button>
      }@else if (cliente.solicitudesCrediticias[0]?.vencido?.monto){
        <button type="button" [disabled]="anulando" (click)="anularPendiente(i, 0, cliente.solicitudesCrediticias[0], accionEliminar.Vencido)"
                class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
          <i class="fa fa-trash" style="transform: scale(1.5)"></i>
        </button>
      } @else {
        <button type="button" [disabled]="anulando" (click)="anularPendiente(i, 0, cliente.solicitudesCrediticias[0], accionEliminar.Excedido)"
                class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
          <i class="fa fa-trash" style="transform: scale(1.5)"></i>
        </button>
      }
    } @else {
      <div class="d-flex align-items-center">
        <div class="spinner-border text-light spinner-border-sm" role="status"></div>
        <span>Eliminando...</span>
      </div>
    }
  </div>
</td>
@if (cliente.solicitudesCrediticias?.length > 1) {
  <tr style="border-bottom: 2px solid black;">
    <td colspan="11"></td>
  </tr>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td></td>
  <td>
    @if (cliente.solicitudesCrediticias[1]?.excedido){
      <div class="fondo mt-2">
        <p style="margin: 0;">${{cliente.solicitudesCrediticias[1]?.excedido?.monto | number: '1.0-0'}}</p>
        <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[1]?.excedido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[1]?.excedido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
      </div>
    }
  </td>
  <td>
    @if (cliente.solicitudesCrediticias[1]?.excedido){
      <div class="fondo">
        <p style="margin: 0;">${{cliente.situacionExcedido - cliente.solicitudesCrediticias[1]?.excedido?.monto | number: '1.0-0'}}</p>
      </div>
    }
  </td>
  <td></td>
  <td>
    @if (cliente.solicitudesCrediticias[1]?.vencido){
      <div class="fondo mt-2">
        <p style="margin: 0;">${{cliente.solicitudesCrediticias[1]?.vencido?.monto | number: '1.0-0'}}</p>
        <span class="fondo fecha">
                        {{cliente.solicitudesCrediticias[1]?.vencido?.fechaDesde | date: 'dd/MM/yyyy'}} - {{cliente.solicitudesCrediticias[1]?.vencido?.fechaHasta | date: 'dd/MM/yyyy'}}
                      </span>
      </div>
    }
  </td>
  <td>
    @if (cliente.solicitudesCrediticias[1]?.vencido){
      <div class="fondo">
        <p style="margin: 0;">${{cliente.situacionVencido - cliente.solicitudesCrediticias[1]?.vencido?.monto | number: '1.0-0'}}</p>
      </div>
    }
  </td>
  <td>
    <div style="justify-content: center" class="d-flex align-items-center fondo">
      @if (cargandoPendiente[i] && !cargandoPendiente[i][1]){
        <span class="me-2">Pendiente</span>
        @if (cliente.solicitudesCrediticias[1]?.vencido?.monto && cliente.solicitudesCrediticias[1]?.excedido?.monto){
          <button type="button" [disabled]="anulando" (click)="anularPendiente(i,1,  cliente.solicitudesCrediticias[1], accionEliminar.Ambos)"
                  class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
            <i class="fa fa-trash" style="transform: scale(1.5)"></i>
          </button>
        }@else if (cliente.solicitudesCrediticias[1]?.vencido?.monto){
          <button type="button" [disabled]="anulando" (click)="anularPendiente(i, 1, cliente.solicitudesCrediticias[1], accionEliminar.Vencido)"
                  class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
            <i class="fa fa-trash" style="transform: scale(1.5)"></i>
          </button>
        } @else {
          <button type="button" [disabled]="anulando" (click)="anularPendiente(i, 1, cliente.solicitudesCrediticias[1], accionEliminar.Excedido)"
                  class="fondo" style= "border-style: none;" ngbTooltip="Anular pendiente">
            <i class="fa fa-trash" style="transform: scale(1.5)"></i>
          </button>
        }
      } @else {
        <div class="d-flex align-items-center">
          <div class="spinner-border text-light spinner-border-sm" role="status"></div>
          <span>Eliminando...</span>
        </div>
      }
    </div>
  </td>
}
